import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";
import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { useTranslation } from "react-i18next";
import CustomText from "components/base/CustomText";



interface ClusterAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

ClusterAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function ClusterAdd(props:ClusterAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    const [containerClusterName, setContainerClusterName] = useState("");
    const [containerClusterDesc, setContainerClusterDesc] = useState("");
    const [nodeCount, setNodeCount] = useState("1");
    const [containerClusterTemplateId, setContainerClusterTemplateId] = useState("");
    const [azId, setAzId] = useState("");

    const [containerClusterNameWarnYn, setContainerClusterNameWarnYn] = useState(false);
    const [containerClusterList, setContainerClusterTemplateList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [azList, setAzList] = useState<DropdownType[]>([]);
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkClusterData();
                if(successYn) {
                    setExecuteAddYn(true);
                }
            }

        }
    }, [props.clickedConfirmYn]);
    useEffect(() => {
        if(stepIndex === 0) {
            loadContainerClusterTemplateList();
            loadAzList();
        }
    }, [stepIndex])
    useEffect(() => {
        if(executeAddYn) {
            executeAddCluster();
        }
    }, [executeAddYn]);

    function checkClusterData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setContainerClusterNameWarnYn(false);
        let message = "";
        let error = false;
        if(!containerClusterName || !containerClusterTemplateId) {
            message = t("MESSAGE_CONTAINER_CLUSTER_INFO_ENTER_ERROR_MESSAGE")
            if(!containerClusterName) {
                setContainerClusterNameWarnYn(true);
            }
            error = true;
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;
    }


    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function loadContainerClusterTemplateList() {
        requests.get(PLATFORM_URL.CONTAINER_CLUSETER_TEMPLATE)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setContainerClusterTemplateList(response.data.items.map((data)=>{
                    return {value:data.container_cluster_template_id, label:data.container_cluster_template_name, data: data}
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadAzList() {
        requests.get(PLATFORM_URL.AZ)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setAzList(response.data.items.map((data)=>{
                    return {value:data.availability_zone_id, label:data.availability_zone_name}
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function executeAddCluster() {
        const body = {};
        body['container_cluster'] = {
            container_cluster_name: containerClusterName,
            container_cluster_description: containerClusterDesc,
            master_node_count: 1,
            worker_node_count: Number(nodeCount),
            creation_timeout_min: 0,
        }

        body['container_cluster_template'] = {
            container_cluster_template_id: containerClusterTemplateId
        }
        body['availability_zone'] = {
            availability_zone_id: azId
        }

        requests.post(PLATFORM_URL.CONTAINER_CLUSETER, body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_CONTAINER_CLUSTER_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_CONTAINER_CLUSTER_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("CONTAINER_CLUSTER_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("CONTAINER_CLUSTER_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={containerClusterName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setContainerClusterName}
                                warnYn={containerClusterNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={3}
                                width={570}
                                height={100}
                                value={containerClusterDesc}
                                type={"text"}
                                activeYn={true}
                                inputCb={setContainerClusterDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("CONTAINER_CLUSTER_TEMPLATE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={7}
                                width={300} height={36}
                                items={containerClusterList}
                                setValue={setContainerClusterTemplateId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("AZ_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={17}
                                width={300} height={36}
                                items={azList}
                                setValue={setAzId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("CONTAINER_CLUSTER_NODE_COUNT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={8}
                                width={145} height={36}
                                value={nodeCount}
                                type={"number"}
                                activeYn={true}
                                inputCb={setNodeCount}
                                warnYn={false}
                                placeHolderText={t("")}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUSTER_NODE_SELECT")}
                        </Text>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}